export default function VKLiveIcon({ className }: { className?: string }) {
  return (
    <>
      <svg
        width="19"
        className={className}
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 9.11494C0 4.88759 0 2.77391 1.27901 1.43317C1.32918 1.38058 1.38058 1.32918 1.43317 1.27901C2.77391 0 4.88759 0 9.11494 0C13.3423 0 15.456 0 16.7967 1.27901C16.8493 1.32918 16.9007 1.38058 16.9509 1.43317C18.2299 2.77391 18.2299 4.88759 18.2299 9.11494C18.2299 13.3423 18.2299 15.456 16.9509 16.7967C16.9007 16.8493 16.8493 16.9007 16.7967 16.9509C15.456 18.2299 13.3423 18.2299 9.11494 18.2299C4.88759 18.2299 2.77391 18.2299 1.43317 16.9509C1.38058 16.9007 1.32918 16.8493 1.27901 16.7967C0 15.456 0 13.3423 0 9.11494Z"
          fill="var(--oda-primary-color)"
        />
        <path
          d="M2.9612 7.63434C2.9612 4.82445 2.9612 3.41951 3.55114 2.36608C3.96808 1.62158 4.58278 1.00688 5.32728 0.589945C6.3807 0 7.78565 0 10.5955 0C13.4054 0 14.8104 0 15.8638 0.589945C16.6083 1.00688 17.223 1.62158 17.6399 2.36608C18.2299 3.41951 18.2299 4.82445 18.2299 7.63434V10.5955C18.2299 13.4054 18.2299 14.8104 17.6399 15.8638C17.223 16.6083 16.6083 17.223 15.8638 17.6399C14.8104 18.2299 13.4054 18.2299 10.5955 18.2299C7.78565 18.2299 6.3807 18.2299 5.32728 17.6399C4.58278 17.223 3.96808 16.6083 3.55114 15.8638C2.9612 14.8104 2.9612 13.4054 2.9612 10.5955V7.63434Z"
          fill="var(--oda-primary-color)"
        />
        <path
          d="M7.31046 6.45558C7.31046 5.52451 8.32272 4.94638 9.12465 5.41943L13.7898 8.17133C14.5788 8.63677 14.5788 9.77818 13.7898 10.2436L9.12465 12.9955C8.32272 13.4686 7.31046 12.8904 7.31046 11.9594V6.45558Z"
          fill="var(--oda-color-150)"
        />
      </svg>
    </>
  );
}
